import { createContext, useContext } from 'react';
import type { SidePanelState } from '@direct-frontend/components';

type SidePanelAnimationState = {
    animationEnd?: SidePanelState;
};

export const SidePanelAnimationContext = createContext<SidePanelAnimationState | null>(null);

export function useSidePanelAnimationContext() {
    const context = useContext(SidePanelAnimationContext);

    if (!context) {
        throw new Error('Hook useSidePanelAnimationContext is called outside of SidePanelAnimationContext');
    }

    return context;
}
